import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-refer',
  templateUrl: './refer.component.html',
  styleUrls: ['./refer.component.css']
})
export class ReferComponent {
createForm = new FormGroup({
    remarks: new FormControl(null)
  })

  submitForm(){
    
  }
}
